module.exports = __webpack_public_path__ + "img/logo_notebook.1889f1cf.png";